import React, { useState } from "react";

const QuestionRating = ({ question, defaultValue, onAnswer }) => {
	const [hoverRating, setHoverRating] = useState(0);

	return (
		<div className="flex flex-col items-center bg-white p-4 px-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			{question.category && (
				<div className="text-sm text-gray-800 font-bold mb-2">
					{question.category}:
				</div>
			)}
			<h3 className="text-sm mb-4">{question.text}</h3>
			{[1, 2, 3, 4, 5].map((star) => (
				<button
					key={star}
					onClick={() => onAnswer(star)}
					onMouseEnter={() => setHoverRating(star)}
					onMouseLeave={() => setHoverRating(0)}
					className={`p-2 ${
						defaultValue >= star || hoverRating >= star
							? "text-yellow-400"
							: "text-gray-300"
					}`}
				>
					★
				</button>
			))}
		</div>
	);
};

export default QuestionRating;
